import React, { Component } from 'react';
// eslint-disable-next-line no-unused-vars
import Activity from './Activities'
import * as Business from '../../utils/business'

export default class Activities extends Component {
    render() {
        return (
            <div className="content">
                <div className="container-fluid">
                    <div className="row">
                        <Activity />
                    </div>
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// src/pages/Activities/index.js